import React from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const TournamentSelector = ({ 
  tournaments, 
  selectedTournament, 
  onTournamentChange,
  pendingCount = 0 
}) => {
  const tournamentOptions = tournaments?.map(tournament => ({
    value: tournament?.id,
    label: tournament?.name,
    description: `${tournament?.format} • ${tournament?.status}`
  }));

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex-1">
          <Select
            label="Select Tournament"
            description="Choose a tournament to manage results"
            options={tournamentOptions}
            value={selectedTournament}
            onChange={onTournamentChange}
            searchable
            placeholder="Search tournaments..."
            className="max-w-md"
          />
        </div>
        
        {pendingCount > 0 && (
          <div className="flex items-center gap-3 px-4 py-3 bg-warning/10 border border-warning/20 rounded-lg">
            <Icon name="AlertCircle" size={20} color="var(--color-warning)" />
            <div>
              <p className="text-sm font-medium text-foreground">
                {pendingCount} Pending Result{pendingCount !== 1 ? 's' : ''}
              </p>
              <p className="text-xs text-muted-foreground">
                Awaiting result entry
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TournamentSelector;